<template>
  <div>
    <div class="h-handle-bg">
      <div class="h-handle-button">
        <p class="h-return">
          <el-button type="text" size="small" @click="config.isDetailDisplay = false">返回</el-button>
        </p>
        <el-button type="primary" size="small" @click="addRule" v-right-code="'Ruletoordermerge:Getemptydto'">新增</el-button>
        <el-button type="primary" size="small" v-right-code="'Ruletoordermerge:Addruletoordermerge'" @click="saveRule">保存</el-button>
      </div>
    </div>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane name="tabbasic">
        <span slot="label">基本信息</span>
        <div class="form-list">
          <el-form :model="dataSource" ref="_ruleForm" :rules="projectCheckRule">
            <el-form-item>
              <el-col :span="4" class="form-title"><span style="color: red">*</span>规则名称：</el-col>
              <el-col :span="8">
                <el-form-item prop="RuleName">
                  <el-input type="text" v-model="dataSource.RuleName" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" class="form-title">
                <span style="color: red">*</span>货主名称：</el-col>
              <el-col :span="8">
                  <ChooseCustomer v-model="dataSource.CustomerCode" :customerName.sync="dataSource.CustomerName" :onChange="customerChange"></ChooseCustomer>
              </el-col>
              </el-form-item>
            <el-form-item>
               <el-col :span="4" class="form-title"><span style="color: red">*</span><span>状态：</span></el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-radio v-model="dataSource.EnableStatus" label="100">启用</el-radio>
                  <el-radio v-model="dataSource.EnableStatus" label="200">停用</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="4" class="form-title">优先级：</el-col>
              <el-col :span="8">
                <el-form-item prop="Priority">
                  <el-input type="number" v-model="dataSource.Priority"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4" class="form-title">单据类型：</el-col>
              <el-col :span="8">
                <el-form-item prop="BusinessType">
                 <el-select v-model="dataSource.BusinessType" filterable placeholder="请选择">
                    <el-option v-for="item in businessTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-col :span="4" class="form-title">规则描述：</el-col>
              <el-col :span="20">
                <el-form-item prop="Remark">
                  <el-input type="textarea" maxlength="200" :rows="2" placeholder="请输入内容" v-model="dataSource.Remark">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-tabs type="border-card" v-model="activeNameResult">
      <el-tab-pane name="tabResult" label=" ">
        <span>合单维度（勾选后，所选运输调度单的对应字段必须完全一致才会合单）</span>
        <br><br>
        <el-checkbox v-model="dataSource.MergeByCustomer">按货主</el-checkbox>
        <el-checkbox v-model="dataSource.MergeByReceiveCustomer">按收货客户</el-checkbox>
        <el-checkbox v-model="dataSource.MergeByReceiveAddress">按收货地址</el-checkbox>
        <el-checkbox v-model="dataSource.MergeByReceivePhone">按收货电话</el-checkbox>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    var _this = this;
    var checkRuleName = function (rule, value, callback) {
      if (!value) return callback(new Error("请输入规则名称"));
      if(_this.Utils.isEmpty(value)) return callback(new Error("请输入规则名称"));
      callback();
    };
    
    return {
      activeName: "tabbasic",
      activeNameResult: 'tabResult',
      multipleSelection: [],
      isDisabled: false,
      projectCheckRule: {
        RuleName: [{ validator: checkRuleName, trigger: "blur" }],
      },
      businessTypeList: [
        { Value: 104, Label: "采购入库" },
        { Value: 116, Label: "销退入库" },
        { Value: 300, Label: "销售出库" },
        { Value: 500, Label: "采退出库" },
        { Value: 201, Label: "调拨单" },
        { Value: 400, Label: "调拨出库" },
        { Value: 200, Label: "调拨入库" },
      ],
      configdataSource: {
        ColDefs: {},
        Result: [],
        TotalCount: 0,
      },
    };
  },
  props: {
    config: {
      isDetailDisplay: false,
    },
    dataSource: {},
  },
  computed: {},
  watch: {
    dataSource: {
      handler(curVal, oldVal) {
        this.isDisabled = this.Utils.emptyGuid != this.dataSource.WarehouseProjectID;
      },
      deep: true,
    },
  },

  mounted() {
    this.Event.$on("clearEditruletoordermergeForm", () => this.resetForm);
  },

  methods: {
    addRule: function () {
      this.Event.$emit("onAddRule");
    },
    saveRule: function () {
      var _this = this;
      if(_this.dataSource.DisplayEnableStatus!=undefined)
      {
        delete _this.dataSource.DisplayEnableStatus;
      }
      if(_this.dataSource.DisplayBusinessType!=undefined)
      {
        delete _this.dataSource.DisplayBusinessType;
      }
      
      _this.$refs["_ruleForm"].validate((valid) => {
        _this.isPassValidate = valid;
        if (valid) {
          if(_this.dataSource.CustomerCode==null || _this.dataSource.CustomerCode.length==0)
          {
              _this.Utils.messageBox("未选择货主名称", "error");
              return ;
          }

          var routeName =
            (_this.dataSource.Id === "0" || _this.dataSource.Id === 0 || _this.dataSource.Id == null)
              ? "addruletoordermerge"
              : "editruletoordermerge";

          _this.$ajax.send(
            "omsapi/ruletoordermerge/" + routeName,
            "post",
            _this.dataSource,
            (data) => {
              if (data.IsSuccess) {
                _this.Utils.messageBox(data.OperationDesc, "success");
                _this.$parent.syncDataSource();
                _this.Event.$emit("reloadRuleList");
                _this.dataSource.Id = 0;
                _this.$refs["_ruleForm"].resetFields();
                _this.dataSource.MergeByCustomer=false;
                _this.dataSource.MergeByReceiveCustomer=false;
                _this.dataSource.MergeByReceiveAddress=false;
                _this.dataSource.MergeByReceivePhone=false;
              } else {
                _this.Utils.messageBox(data.OperationDesc, "error");
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    resetForm() {
      !this.isPassValidate && this.$refs["_ruleForm"].resetFields();
      this.dataSource.EnableStatus = "100";
      this.dataSource.MergeByCustomer = false;
      this.dataSource.MergeByReceiveCustomer = false;
      this.dataSource.MergeByReceiveAddress = false;
      this.dataSource.MergeByReceivePhone = false;
    },
    customerChange(){
    },

    initialize() {
      this.onPageChange(this.queryParam);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("onCheckRow", this.multipleSelection);
    },
    onPageChange(param) {
      var _this = this;
      this.queryParam = param;
    },
  },
  components: {
  },
};
</script>

<style>
.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
